import {
  OBTER_CONTRATOS_REQUEST,
  OBTER_CONTRATOS_SUCCESS,
  OBTER_DADOS_SOLICITACAO_REQUEST,
  OBTER_DADOS_SOLICITACAO_SUCCESS,
  OBTER_LIMITE_EMPRESTIMO_REQUEST,
  OBTER_LIMITE_EMPRESTIMO_SUCCESS,
  RESET_EMPRESTIMO,
  SET_SIMULATION,
} from './constants';

export function obterContratosRequest() {
  return {
    type: OBTER_CONTRATOS_REQUEST,
  };
}

export function obterContratosSuccess(contratos) {
  return {
    type: OBTER_CONTRATOS_SUCCESS,
    payload: contratos,
  };
}

export function setSimulation({ valor, parcelas }) {
  return {
    type: SET_SIMULATION,
    payload: {
      valor,
      parcelas,
    },
  };
}

export function obterDadosSolicitacaoRequest() {
  return {
    type: OBTER_DADOS_SOLICITACAO_REQUEST,
  };
}

export function obterDadosSolicitacaoSuccess(payload) {
  return {
    type: OBTER_DADOS_SOLICITACAO_SUCCESS,
    payload,
  };
}

export function obterLimiteEmprestimoRequest() {
  return {
    type: OBTER_LIMITE_EMPRESTIMO_REQUEST,
  };
}

export function obterLimiteEmprestimoSuccess(limite) {
  return {
    type: OBTER_LIMITE_EMPRESTIMO_SUCCESS,
    payload: limite,
  };
}

export function resetEmprestimos() {
  return {
    type: RESET_EMPRESTIMO,
  };
}
